module.exports = __webpack_public_path__ + "static/media/google.bc8f41c8.svg";